import type { ReactNode } from 'react';

export function Columns({ children }: { children?: ReactNode }) {
  return (
    <div className="my-6 grid grid-cols-1 md:grid-cols-2 gap-6">
      {children}
    </div>
  );
}

export function Col({ children }: { children?: ReactNode }) {
  return (
    <div className="[&>p:first-child]:mt-0 [&>p:last-child]:mb-0 [&>h3:first-child]:mt-0 [&>h4:first-child]:mt-0">
      {children}
    </div>
  );
}
